export default __webpack_public_path__ + "static/media/ic_search.40d997d1.svg";